import {Injectable} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';

@Injectable()
export class SessionService {

  constructor(private cookieService: CookieService) {
  }

  getCustomerId(): number {
    return parseInt(this.cookieService.get('companyID'), 10);
  }

  getLocale(): string {
    return this.cookieService.get('locale');
  }

  getPermissions(): string[] {

    const permissions: string = window.localStorage.getItem('login.user.permissions');

    return permissions.split(',');
  }

  getPermittedGroupsId(): string[] {
    const groupIds: string = this.cookieService.get('groupIds');

    return groupIds.split(',');
  }

  getUserId(): number {
    return parseInt(this.cookieService.get('userId'), 10);
  }

  getUserName(): string {
    return this.cookieService.get('username');
  }
}
